exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-btn--outlined[data-v-7d2c1ca2]{border-color:#fff!important}.dtv-app-bar[data-v-7d2c1ca2]{background-color:#1d2329}.no-uppercase[data-v-7d2c1ca2]{text-transform:none}", ""]);

// exports
